
import { Component, Vue, Watch } from "vue-property-decorator";
import { PageMode } from "@/utils/type";
import MaterialSelect from "@/components/material-select/index.vue";
import Specification from "./components/specification.vue";
import ModelDetails from "./components/details.vue";
import ModelAttrs from "./components/attrs.vue";
import PopoverInput from "@/components/popover-input.vue";
import { apiShopModelListDetail } from "@/api/shop.ts";
import { deepClone } from "@/utils/util";
const other_details_origin = [
  {
    zh_cn_title: "印刷说明",
    en_title: "Printed instructions",
    children: [
      {
        zh_cn_name: "DTG打印",
        en_name: "DTG printing",
        zh_cn_value: "无",
        en_value: "None",
      },
      {
        zh_cn_name: "生产工艺",
        en_name: "Production process",
        zh_cn_value: "无",
        en_value: "None",
      },
    ],
  },
  {
    zh_cn_title: "设计风格",
    en_title: "Design style",
    children: [
      {
        zh_cn_name: "推荐风格",
        en_name: "Recommended style",
        zh_cn_value: "无",
        en_value: "None",
      },
      {
        zh_cn_name: "主题元素",
        en_name: "Theme elements",
        zh_cn_value: "无",
        en_value: "None",
      },
    ],
  },
  {
    zh_cn_title: "材质说明",
    en_title: "Material description",
    children: [
      {
        zh_cn_name: "弹力指数",
        en_name: "Stretch index",
        zh_cn_value: "无",
        en_value: "None",
      },
      {
        zh_cn_name: "柔软指数",
        en_name: "Softness index",
        zh_cn_value: "无",
        en_value: "None",
      },
    ],
  },
  {
    zh_cn_title: "商品特征",
    en_title: "Product features",
    children: [
      {
        zh_cn_name: "设计说明",
        en_name: "Design Description",
        zh_cn_value: "无",
        en_value: "None",
      },
      {
        zh_cn_name: "材质说明",
        en_name: "PMaterial Description",
        zh_cn_value: "无",
        en_value: "None",
      },
    ],
  },
];
@Component({
  components: {
    MaterialSelect,
    Specification,
    ModelAttrs,
    ModelDetails,
    PopoverInput,
  },
})
export default class ModelEdit extends Vue {
  $refs!: { dataForm: any };
  /** S Data **/
  mode: string = PageMode.ADD; // 当前页面: add-添加角色 edit-编辑角色
  pager: any;
  searchObj: any;
  // 表
  lists: Array<object> = [];
  activeName = "basic";
  addVideo = false;

  // 表单数据
  dataForm: any = {
    share_way: 2,
    zh_cn_title: "",
    en_title: "",
    image: "",
    goods_image: [],
    cate_id: "",
    status: 1,
    sort: 1,
    img_format: "",
    factoryimg_type: 0,
    desc_list: [{}, {}],
    product_image: "",
    tag_ids: [],
    video: "",
    video_source: 1,
    video_cover: "",
    send_source: 1, //1国内发货2海外本土盘
    factory_address_id: "",
    is_real_size: 0, // 是否根据实际尺寸计算运费
    model_extra: {
      attrs: [],
      average_production_time: "",
      ninety_production_time: "",
      ensure_production_time: "",
      other_details: [],
      zh_cn_material: "",
      en_material: "",
    },
    spec_value_list: [
      {
        id: "",
        image: "",
        factory_price: "",
        volume: "",
        weight: "",
        width: "",
        length: "",
        high: "",
      },
    ],
  };

  // 规格绑定的数据
  specData: any = {
    spec_type: 1,
    spec_value: [],
    spec_value_list: [],
  };
  attrData: any = [];

  other_details: any = [];

  /** E Data **/
  @Watch("specData", { deep: true })
  specDataChange(val: any) {
    this.dataForm.spec_value_list = val.spec_value_list;
    this.dataForm.spec_value = val.spec_value;
  }

  @Watch("attrData", { deep: true })
  attrDataChange(val: any) {
    this.dataForm.model_extra.attrs =
      typeof val === "string" ? JSON.parse(val) : val;
  }
  @Watch("dataForm.video", { immediate: true })
  videoChange(val: string) {
    if (val) {
      this.addVideo = true;
    }
  }
  /** S Methods **/

  getDetail() {
    apiShopModelListDetail({ id: this.dataForm.id }).then((res: any) => {
      this.dataForm = res;

      if (!this.dataForm.model_extra) {
        this.dataForm.model_extra = {
          attrs: [],
          average_production_time: "",
          ninety_production_time: "",
          ensure_production_time: "",
          other_details: [],
          zh_cn_material: "",
          en_material: "",
          nodesign_img: 1,
        };
      }
      if (!this.dataForm.model_extra.other_details) {
        this.other_details = deepClone(other_details_origin);
      } else {
        this.other_details = deepClone(this.dataForm.model_extra.other_details);
      }
      this.initData(res);
    });
  }

  // 初始化规格数据
  initData(data: any = {}) {
    const spec_value = [
      {
        has_image: false,
        id: "",
        name: "",
        spec_list: [
          {
            id: "",
            value: "",
            image: "",
          },
        ],
      },
    ];
    const spec_value_list = [
      {
        id: "",
        image: "",
        sell_price: "",
        lineation_price: "",
        factory_price: "",
        cost_price: "",
        stock: "",
        volume: "",
        weight: "",
        bar_code: "",
      },
    ];

    const specData: any = {
      spec_value: data.spec_value || spec_value,
      spec_value_list: data.spec_value_list || spec_value_list,
    };
    specData.spec_value.forEach((item: any) => {
      item.has_image = false;
      item.spec_list.forEach((sitem: any) => {
        sitem.image = "";
      });
    });
    Object.assign(this.specData, specData);
    this.attrData = data.model_extra.attrs || [];
  }

  /** E Methods **/

  /** S Life Cycle **/
  mounted() {}

  back() {
    this.$router.push({
      name: "model_lists",
      params: {
        page_no: this.pager as any,
        searchObj: this.searchObj as any,
      },
    });
  }

  /** E Methods **/

  /** S Life Cycle **/
  created() {
    const query: any = this.$route.query;
    if (query.mode) this.mode = query.mode;
    if (query.page_no) this.pager = query.page_no;
    if (query.preSearchObj) this.searchObj = query.preSearchObj;
    if (this.mode === PageMode.EDIT) {
      this.dataForm.id = query.id * 1;
      this.getDetail();
    }
  }

  /** E Life Cycle **/
}
